const en_master_division = {
    "": "user group",
    add: "add user group",
    edit: "edit user group",
    view: "user group details",

    label: {
        name: 'user group name',
        user_btn_add: 'add user',
        user_title: 'user list',
    },

    success: {
        create: 'User group created successfully',
        edit: 'User group updated successfully',
    },

    error: {
        name: 'user group name is required',

        create: 'Failed to create user group',
        edit: 'Failed to update user group',
    },
}


export default en_master_division;